import React, { useState } from "react";
import "./index.css";
import DashboardNavbar from "./navbar";
import Attendance from "../../components/common/Attendance";
import Mpp from "./mpp";
import Test from "./test";
import Classes from "./classes";
import AITSBanner from "./components/aits-banner";
import OnlineCoursePopup from "./onlineCoursePopup";
import SuccessPopup from "./successPopup";
import ErrorPopup from "./errorPopup";
import { useTimer } from "../../Student/genericV2/common/use-timer";
import { useDispatch, useSelector } from "react-redux";
import useMediaQuery from "../../utils/hooks/use-media-query";
import { ToastContainer } from "react-toastify";
import { resetCornerState, startDashboardLoader } from "../../store/actions";
import Api from "../../common/Api";
import ApiUrl from "../../common/ApiUrl";
import { segmentEvents, dashboardIds, restrictedSchoolAssocIds } from "../../utils/constants";
import NCERTNEW from "./ncert";
import JEECorner from "./jee";
import NEETCorner from "./neet";
import { requestACall } from "../../utils/helperFunctions";
import Layout from "../../components/layout";
import Swal from "sweetalert2";

const isScrolledIntoView = (el, offset = -100) => {
	const top = el.getBoundingClientRect().top;
	return top + offset >= 0 && top - offset <= window.innerHeight;
};

const IDs = Object.values(dashboardIds).reverse();

const Dashboard = () => {
	const {
		attendance,
		banner,
		classes,
		dpps,
		exams,
		loadingAttendance,
		loadingExams,
		loadingDpps,
		loadingClasses,
		loadingBanner,
		attendanceDates,
		loadingAttendanceDates,
		holidayList
	} = useSelector((state) => state.dashboard);
	const dispatch = useDispatch();
	let data = localStorage.getItem("userdetail");
	data = data && JSON.parse(data);
	const token = data?.token;
	const { student_data: studentData, student_subjects: studentSubjects } = useSelector(
		(state) => state.StudentDetail?.StudentDetail ?? {}
	);
	const { time, start: startTimer } = useTimer({ timerType: "DECREMENTAL" });
	const [onlineModalOpen, setOnlineModalOpen] = useState(false);
	const [activeSection, setActiveSection] = useState(null);
	const debounce = React.useRef(false);
	const stopScrollListner = React.useRef(false);
	const holidayPopupShown = React.useRef(false);
	const getHolidayPopupDateStatus = () => {
		const holidayDate = "14/04/2026";
		const [day, month, year] = holidayDate.split("/").map(Number);
		const holidayDateObj = new Date(year, month - 1, day);
		holidayDateObj.setHours(0, 0, 0, 0);

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		return {
			shouldShow: today.getTime() <= holidayDateObj.getTime(),
			isHolidayToday: today.getTime() === holidayDateObj.getTime(),
		};
	};
	const loading = loadingAttendance || loadingDpps || loadingExams || loadingClasses || loadingBanner || !studentData;
	const isMobile = useMediaQuery("(max-width: 991px)");
	const isRestricted = !!studentData && restrictedSchoolAssocIds.includes(String(studentData.school_assoc.id));

	const onlineModalOpenHandler = () => {
		setOnlineModalOpen(true);
		Api.trackEvent(segmentEvents.FREEDASHBOARD.HEADER_ENROLL);
		Api.moEngageTrackEvent("Web - Free user Enroll clicked", {
			Timestamp: Date(),
			"course name": banner.course_name,
		});
	};

	const onlineModalCloseHandler = () => {
		setOnlineModalOpen(false);
	};

	const [successModalOpen, setSuccessModalOpen] = useState(false);
	const [errorModalOpen, setErrorModalOpen] = useState(false);

	const successModalOpenHandler = () => {
		setSuccessModalOpen(true);
		setTimeout(() => {
			window.location.reload();
			dispatch(startDashboardLoader());
			setSuccessModalOpen(false);
		}, 5000);
		startTimer(5);
	};

	const errorModalOpenHandler = () => {
		setErrorModalOpen(true);
		setTimeout(() => {
			setErrorModalOpen(false);
		}, 3500);
	};

	React.useEffect(() => {
		if (loading || isMobile) return;
		const scrollListner = () => {
			if (stopScrollListner.current) return;
			if (!debounce.current) {
				debounce.current = true;
				setTimeout(() => {
					IDs.forEach((id) => {
						const el = document.getElementById(id);

						if (el) {
							if (isScrolledIntoView(el)) {
								setActiveSection(id);
							}
						}
					});
					debounce.current = false;
				}, 50);
			}
		};
		window.addEventListener("scroll", scrollListner);
		return () => {
			window.removeEventListener("scroll", scrollListner);
		};
	}, [loading, isMobile]);

	React.useEffect(() => {
		if (activeSection) return;
		if (!studentData) return;
		if (studentData.is_free) {
			setActiveSection(dashboardIds.NCERT);
		} else {
			setActiveSection(dashboardIds.MPP);
		}
		console.log(studentData);
	}, [studentData]);

	React.useEffect(() => {
		dispatch(resetCornerState());
	}, []);

	React.useEffect(() => {
		if (!studentData?.id || holidayPopupShown.current) return;
		const { shouldShow, isHolidayToday } = getHolidayPopupDateStatus();

		if (!shouldShow) return;

		Api.doFetch("GET", {}, `${ApiUrl.GET_STUDENT_COURSE_LIST}?student_id=${studentData.id}`)
			.then((response) => {
				if (response.status != true) return;

				const courses = Array.isArray(response?.data?.courses) ? response.data.courses : [];
				const hasBridgeMar23Course = courses.some((course) =>
					(course?.section_name || "").includes("_Bridge_Mar23")
				);

				if (hasBridgeMar23Course) {
					holidayPopupShown.current = true;
					Swal.fire({
						title: "📢 Holiday Announcement",
						html: `
							<p>Dear Students,</p>
							<p>${isHolidayToday ? "Today" : "Tomorrow"} (14/04/2026) is declared a holiday on account of Ambedkar Jayanti.</p>
							<p>Classes will resume as usual on 15/04/2026.</p>
						`,
						icon: "info",
						confirmButtonText: "OK",
						width: "50%",
						padding: "30px",
					});
				}
			})
			.catch(() => {});
	}, [studentData]);

	return (
		<Layout>
			{!loading && (
				<div className="dashboard_container">
					{banner.show_banner && !banner.post_enrollment && (
						<OnlineCoursePopup
							open={onlineModalOpen}
							handleClose={onlineModalCloseHandler}
							successModalOpenHandler={successModalOpenHandler}
							errorModalOpenHandler={errorModalOpenHandler}
							banner={banner}
							studentData={studentData}
						/>
					)}

					<SuccessPopup open={successModalOpen} time={time} />
					<ErrorPopup open={errorModalOpen} />

					{banner.show_banner && <AITSBanner banner={banner} onlineModalOpenHandler={onlineModalOpenHandler} />}

					<div className="dashboard_layout">
						{!isRestricted&&<div className="dashboard_nav">
							<DashboardNavbar
								stopScrollListner={stopScrollListner}
								activeSection={activeSection}
								setActiveSection={setActiveSection}
								isFree={studentData.is_free}
							/>
						</div>}
						{studentData.is_free ? (
							<div className={`dashboard_content${isRestricted ? " dashboard_content_full" : ""}`}>
								{/* <div
									style={{
										marginTop: "-4rem",
									}}>
									<NCERTNEW active={activeSection === dashboardIds.NCERT} />
								</div>
								<JEECorner active={activeSection === dashboardIds.JEE} />
								<NEETCorner active={activeSection === dashboardIds.NEET} />
								<div
									style={{
										marginTop: "4rem",
									}}>
									<Mpp
										active={activeSection === dashboardIds.MPP}
										dpps={dpps}
										studentData={studentData}
										token={token}
										isFree
										requestACall={requestACall}
									/>
								</div> */}
								<Test
									active={activeSection === dashboardIds.TESTS}
									exams={exams}
									studentData={studentData}
									token={token}
									isFree
									studentSubjects={studentSubjects}
									requestACall={requestACall}
								/>
								<Classes
									classes={classes}
									active={activeSection === dashboardIds.CLASSES}
									isFree
									requestACall={requestACall}
								/>
							</div>
						) : (
							<div className={`dashboard_content${isRestricted ? " dashboard_content_full" : ""}`}>
								{!isRestricted&&<Mpp
									active={activeSection === dashboardIds.MPP}
									dpps={dpps}
									studentData={studentData}
									token={token}
								/>}
								<Test
									active={activeSection === dashboardIds.TESTS}
									exams={exams}
									studentData={studentData}
									token={token}
									studentSubjects={studentSubjects}
								/>
								{!isRestricted&&<Classes classes={classes} active={activeSection === dashboardIds.CLASSES} />}
								{!isRestricted&&<NCERTNEW active={activeSection === dashboardIds.NCERT} />}
								{!isRestricted&&<JEECorner active={activeSection === dashboardIds.JEE} />}
								{!isRestricted&&<NEETCorner active={activeSection === dashboardIds.NEET} />}
							</div>
						)}

						{!isRestricted&&<div className="dashboard_attendance" style={{ ...(studentData?.is_free && { overflow: "hidden" }) }}>
							<Attendance
								isFree={studentData.is_free}
								attendance={attendance}
								studentSubjects={studentSubjects}
								requestACall={requestACall}
								attendanceDates={attendanceDates}
								holidayList={holidayList}
								studentName={studentData?.name || ""}
								studentId={studentData?.id || ""}
								studentMobile={studentData?.mobile_number || ""}
							/>
						</div>}
					</div>
				</div>
			)}
			<ToastContainer />
		</Layout>
	);
};

export default Dashboard;
